export const ConfirmationGraphic: React.FC = () => (
  <svg
    width="620"
    height="336"
    viewBox="0 0 620 336"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g filter="url(#filter0_d_155_1037)">
      <g clipPath="url(#clip0_155_1037)">
        <rect x="-150" y="-360" width="920" height="784" rx="6" fill="white" />
        <g filter="url(#filter1_d_155_1037)">
          <g filter="url(#filter2_d_155_1037)">
            <g clipPath="url(#clip1_155_1037)">
              <rect width="619.837" height="826" rx="4.04241" fill="white" />
              <rect
                x="16.1694"
                y="76.8059"
                width="106.45"
                height="13.4747"
                rx="6.73736"
                fill="#C2C6CC"
              />
              <rect
                x="16.1694"
                y="111.84"
                width="50.5302"
                height="9.4323"
                rx="4.71615"
                fill="#C2C6CC"
              />
              <rect
                x="243.219"
                y="111.84"
                width="16.1697"
                height="9.4323"
                rx="4.71615"
                fill="#C2C6CC"
              />
              <rect
                x="16.1694"
                y="129.357"
                width="82.8695"
                height="10.7798"
                rx="5.38989"
                fill="#AAADB3"
              />
              <rect
                x="243.219"
                y="129.357"
                width="26.9494"
                height="10.7798"
                rx="5.38989"
                fill="#AAADB3"
              />
              <rect
                x="16.1694"
                y="162.37"
                width="28.9706"
                height="9.4323"
                rx="4.71615"
                fill="#C2C6CC"
              />
              <rect
                x="318.003"
                y="162.37"
                width="75.4584"
                height="9.4323"
                rx="4.71615"
                fill="#C2C6CC"
              />
              <rect
                x="318.003"
                y="215.595"
                width="86.2382"
                height="9.4323"
                rx="4.71615"
                fill="#C2C6CC"
              />
              <rect
                x="318.003"
                y="179.887"
                width="82.8695"
                height="10.7798"
                rx="5.38989"
                fill="#AAADB3"
              />
              <rect
                x="16.1694"
                y="179.887"
                width="39.0767"
                height="10.7798"
                rx="5.38989"
                fill="#AAADB3"
              />
              <rect
                x="318.003"
                y="231.765"
                width="82.8695"
                height="10.7798"
                rx="5.38989"
                fill="#AAADB3"
              />
              <rect
                x="16.1694"
                y="215.595"
                width="50.5302"
                height="9.4323"
                rx="4.71615"
                fill="#C2C6CC"
              />
              <rect
                x="16.1694"
                y="233.113"
                width="82.8695"
                height="10.7798"
                rx="5.38989"
                fill="#AAADB3"
              />
              <rect
                x="317.329"
                y="111.84"
                width="50.5302"
                height="9.4323"
                rx="4.71615"
                fill="#C2C6CC"
              />
              <rect
                x="317.329"
                y="129.357"
                width="82.8695"
                height="10.7798"
                rx="5.38989"
                fill="#AAADB3"
              />
              <path
                d="M16.5063 146.874H227.723"
                stroke="#E7EBF2"
                strokeWidth="0.673736"
                strokeLinecap="round"
              />
              <path
                d="M243.219 146.874H299.139"
                stroke="#B6B2B2"
                strokeWidth="0.673736"
                strokeLinecap="round"
              />
              <path
                d="M318.003 146.874H603.667"
                stroke="#E7EBF2"
                strokeWidth="0.673736"
                strokeLinecap="round"
              />
              <path
                d="M318.003 197.405H603.667"
                stroke="#E7EBF2"
                strokeWidth="0.673736"
                strokeLinecap="round"
              />
              <path
                d="M16.1694 197.405H301.833"
                stroke="#E7EBF2"
                strokeWidth="0.673736"
                strokeLinecap="round"
              />
              <path
                d="M16.1694 250.63H301.833"
                stroke="#E7EBF2"
                strokeWidth="0.673736"
                strokeLinecap="round"
              />
              <path
                d="M16.1694 319.351H301.833"
                stroke="#E7EBF2"
                strokeWidth="0.673736"
                strokeLinecap="round"
              />
              <path
                d="M318.003 319.351H603.667"
                stroke="#E7EBF2"
                strokeWidth="0.673736"
                strokeLinecap="round"
              />
              <rect
                x="16.1694"
                y="267.473"
                width="15.4959"
                height="16.1697"
                rx="5.38989"
                fill="#C2C6CC"
              />
              <rect
                opacity="0.2"
                x="16.1694"
                y="291.728"
                width="15.4959"
                height="16.1697"
                rx="5.38989"
                fill="#C2C6CC"
              />
              <rect
                x="37.729"
                y="271.516"
                width="39.0767"
                height="9.4323"
                rx="4.71615"
                fill="#C2C6CC"
              />
              <rect
                opacity="0.2"
                x="37.729"
                y="295.77"
                width="140.811"
                height="9.4323"
                rx="4.71615"
                fill="#C2C6CC"
              />
              <rect
                x="318.003"
                y="267.473"
                width="15.4959"
                height="16.1697"
                rx="5.38989"
                fill="#C2C6CC"
              />
              <rect
                opacity="0.2"
                x="318.003"
                y="291.728"
                width="15.4959"
                height="16.1697"
                rx="5.38989"
                fill="#C2C6CC"
              />
              <rect
                x="339.562"
                y="271.516"
                width="200.1"
                height="9.4323"
                rx="4.71615"
                fill="#C2C6CC"
              />
              <rect
                opacity="0.2"
                x="339.562"
                y="295.77"
                width="115.883"
                height="9.4323"
                rx="4.71615"
                fill="#C2C6CC"
              />
              <path
                d="M318.003 250.63H603.667"
                stroke="#E7EBF2"
                strokeWidth="0.673736"
                strokeLinecap="round"
              />
              <mask id="path-35-inside-1_155_1037" fill="white">
                <path d="M0 4.04241C0 1.80985 1.80985 0 4.04241 0H615.794C618.027 0 619.837 1.80985 619.837 4.04241V48.509H0V4.04241Z" />
              </mask>
              <path
                d="M0 4.04241C0 1.80985 1.80985 0 4.04241 0H615.794C618.027 0 619.837 1.80985 619.837 4.04241V48.509H0V4.04241Z"
                fill="#EFF8F5"
              />
              <path
                d="M0 0H619.837H0ZM619.837 49.1827H0V47.8352H619.837V49.1827ZM0 48.509V0V48.509ZM619.837 0V48.509V0Z"
                fill="#CEEAE3"
                mask="url(#path-35-inside-1_155_1037)"
              />
              <path
                d="M588.546 26.7776L586.234 24.4369C585.983 24.1864 585.685 24.0612 585.338 24.0612C584.991 24.0612 584.692 24.1961 584.442 24.4658C584.192 24.697 584.066 24.9956 584.066 25.3616C584.066 25.7277 584.192 26.0263 584.442 26.2575L587.621 29.4651C587.871 29.7156 588.179 29.8408 588.546 29.8408C588.912 29.8408 589.22 29.7156 589.47 29.4651L595.943 22.992C596.175 22.7608 596.29 22.4718 596.29 22.1251C596.29 21.7783 596.165 21.4797 595.915 21.2292C595.664 20.9788 595.356 20.8535 594.99 20.8535C594.624 20.8535 594.325 20.9788 594.094 21.2292L588.546 26.7776ZM590.193 36.7185C588.555 36.7185 587.019 36.4103 585.583 35.7938C584.148 35.1773 582.901 34.3393 581.841 33.2797C580.782 32.2201 579.944 30.9728 579.327 29.538C578.711 28.1023 578.402 26.5657 578.402 24.9282C578.402 23.2906 578.711 21.754 579.327 20.3184C579.944 18.8835 580.782 17.6362 581.841 16.5766C582.901 15.5171 584.148 14.679 585.583 14.0625C587.019 13.446 588.555 13.1378 590.193 13.1378C591.83 13.1378 593.367 13.446 594.803 14.0625C596.237 14.679 597.485 15.5171 598.544 16.5766C599.604 17.6362 600.442 18.8835 601.058 20.3184C601.675 21.754 601.983 23.2906 601.983 24.9282C601.983 26.5657 601.675 28.1023 601.058 29.538C600.442 30.9728 599.604 32.2201 598.544 33.2797C597.485 34.3393 596.237 35.1773 594.803 35.7938C593.367 36.4103 591.83 36.7185 590.193 36.7185Z"
                fill="#6ACC74"
              />
            </g>
          </g>
        </g>
      </g>
    </g>
    <defs>
      <filter
        id="filter0_d_155_1037"
        x="-161"
        y="-365"
        width="942"
        height="806"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="6" />
        <feGaussianBlur stdDeviation="5.5" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_155_1037"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_155_1037"
          result="shape"
        />
      </filter>
      <filter
        id="filter1_d_155_1037"
        x="-12"
        y="-11"
        width="643.837"
        height="850"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="1" />
        <feGaussianBlur stdDeviation="6" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_155_1037"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_155_1037"
          result="shape"
        />
      </filter>
      <filter
        id="filter2_d_155_1037"
        x="-7.41109"
        y="-3.36868"
        width="634.659"
        height="840.822"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="4.04241" />
        <feGaussianBlur stdDeviation="3.70555" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_155_1037"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_155_1037"
          result="shape"
        />
      </filter>
      <clipPath id="clip0_155_1037">
        <rect x="-150" y="-360" width="920" height="784" rx="6" fill="white" />
      </clipPath>
      <clipPath id="clip1_155_1037">
        <rect width="619.837" height="826" rx="4.04241" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
